import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungErfurt() {
  return (
    <CityPageTemplate
      city="Erfurt"
      slug="erfurt"
      intro="Erfurt als Landeshauptstadt Thüringens wächst – nutze die Chancen für smarten Vermögensaufbau."
      description="Unabhängige & digitale Finanzberatung für Erfurt: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
